import React from 'react';

export type WidgetLabels = { [key: string]: WidgetLabel }

export interface WidgetLabel {
  banner: string,
  launcher: string,
  contactForm: {
    title: string,
    submit: string,
    confirmation: string
  }
}

type Props = {
  freshdeskToken: string,
  name: string,
  email: string,
  language: string,
  widgetId: Number,
  labels: WidgetLabels,
  defaultLanguage: strings,
}

const WIDGET_SCRIPT_ID = 'freshworks-widget-script';
const WIDGET_UPDATE_DELAY = 2000;

class FreshdeskWidget extends React.Component<Props> {

  componentDidMount() {
    this.init(this.props);
  }

  async componentDidUpdate(prevProps: Props) {
    const { language, freshdeskToken } = this.props;
    const hasLanguageChanged = language && language !== prevProps.language;
    const hasTokenChanged = freshdeskToken && freshdeskToken !== prevProps.freshdeskToken;

    if (hasLanguageChanged || hasTokenChanged) {
      // Workaround to dynamically switch the widget language.
      // The language won't change if the widget is not reinitialize.
      this.destroyWidget();
      this.init(this.props);
    }
  }

  init({ labels, language, widgetId, defaultLanguage, freshdeskToken }) {
    window.fwSettings = {
      'widget_id': widgetId,
      'locale': language || defaultLanguage,
    };

    !(function (...args) {
      if (typeof window.FreshworksWidget !== 'function') {
        const n = function () {
          n.q.push(args);
        };
        n.q = [];
        window.FreshworksWidget = n;
      }
    }());

    const widgetScript = document.createElement('script');
    widgetScript.id = WIDGET_SCRIPT_ID;
    widgetScript.type = 'text/javascript';
    widgetScript.src = `https://widget.freshworks.com/widgets/${widgetId}.js`;
    widgetScript.async = true;
    widgetScript.defer = true;
    document.head.appendChild(widgetScript);

    // Workaround the fact that the widget script is async so there's no way to know when its execution is done
    setTimeout(() => {
      window.FreshworksWidget('setLabels', labels);
      if (freshdeskToken) {
        this.authenticateFreshdesk(freshdeskToken);
      }
    }, WIDGET_UPDATE_DELAY);
  }

  authenticateFreshdesk(token: string) {
    window.FreshworksWidget('authenticate', { token });
  }

  destroyWidget() {
    window.FreshworksWidget('destroy');
    document.getElementById(WIDGET_SCRIPT_ID).remove();
    delete window.FreshworksWidget;
  }

  render() {
    return null;
  }
}

export default FreshdeskWidget;



// WEBPACK FOOTER //
// ./src/common/components/FreshdeskWidget.js